export const dashboard = {
  title: "Pannello intuitivo",
  subtitle: "Gestisci tutti i tuoi scambi da un'interfaccia semplice e moderna",
  features: {
    stats: {
      title: "Statistiche dettagliate",
      description:
        "Segui i tuoi Scambio, scambi e risparmi realizzati in tempo reale",
    },
    notifications: {
      title: "Notifiche intelligenti",
      description: "Ricevi avvisi per nuove richieste e messaggi importanti",
    },
    management: {
      title: "Gestione semplificata",
      description:
        "Gestisci le tue disponibilità, prenotazioni e scambi in pochi clic",
    },
  },
  cta: "Scopri il pannello",
  exchangeConfirmed: "Scambio confermato",
  newRequests: "nuove richieste",
  toReview: "Da esaminare",
};
